import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(marketing)/support/support-content.tsx");
